import React from 'react';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { AccountTypeContainer } from './index.styles';

export interface IAccountType {
  imgSrc: any;
  text: string;
  onClick: () => void;
  className: string;
}

function AccountType(AccountTypeProps: IAccountType) {
  const {
    imgSrc,
    text,
    onClick,
    className
  } = AccountTypeProps;

  return (
    <AccountTypeContainer
      onClick={onClick}
      className={className}
    >
      <Box className='main-container'>
        <Box>
          {imgSrc}
        </Box>
        <Typography variant='subtitle1' className='user-type-text' sx={{
          fontWeight: 'bold',
          fontSize: '18px',
          mt: '10px'
        }}>
          {text}
        </Typography>
      </Box>
    </AccountTypeContainer>
  );
}

export default AccountType;
